export const ViewItemTypesModeEnum = {
    WorkStage: 'Work Stage',
    MaterialsLaborTools: 'Materials/Labor/Tools',
} as const;

export type ViewItemTypesModeType =
    (typeof ViewItemTypesModeEnum)[keyof typeof ViewItemTypesModeEnum];
